var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuroWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 3.51469C18.2188 1.24823 15.2053 0 12 0C8.79469 0 5.78123 1.24823 3.51469 3.51469C1.24823 5.78123 0 8.79469 0 12C0 15.2053 1.24823 18.2188 3.51469 20.4853C5.78123 22.7518 8.79469 24 12 24C15.2053 24 18.2188 22.7518 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12C24 8.79469 22.7518 5.78123 20.4853 3.51469ZM12.4756 18.3281C10.7853 18.3281 9.19622 17.6699 8.001 16.4746C7.31105 15.7847 6.81417 14.9737 6.51009 14.1094H4.97564V12.7031H6.18975C6.13795 12.2359 6.13795 11.7641 6.18975 11.2969H4.97564V9.89062H6.51009C6.81417 9.02634 7.31105 8.21531 8.001 7.52536C10.4683 5.058 14.483 5.058 16.9503 7.52536L15.9559 8.51972C14.0369 6.6007 10.9144 6.60066 8.99531 8.51972C8.58544 8.92959 8.26345 9.39445 8.02866 9.89067H14.8194V11.2969H7.60617C7.53942 11.763 7.53942 12.237 7.60617 12.7031H13.4131V14.1094H8.0287C8.2635 14.6055 8.58548 15.0705 8.99536 15.4803C10.9144 17.3994 14.037 17.3993 15.956 15.4803L16.9503 16.4747C15.7551 17.6699 14.166 18.3281 12.4756 18.3281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroWhite);
export default __webpack_public_path__ + "static/media/euroWhite.68acca6ccb439533e35eff14b1c1e8bf.svg";
export { ForwardRef as ReactComponent };